import MainComponent from "./ContentsView";
import Content from "./components/Content/ContentsViewContent";
import Row from "./components/Row/ContentsViewRow";

interface IContentsViewExtensions {
    Row: typeof Row;
    Content: typeof Content;
}

export const ContentsView: typeof MainComponent & IContentsViewExtensions =
    Object.assign(MainComponent, {
        Row,
        Content,
    });

export type { ContentsViewProps } from "./ContentsView";
